import { type ListItemButtonProps, ListItemButton } from '@mui/material';
import { createContext } from 'react';
import { useLocation } from 'react-router-dom';

export const ListItemButtonSelectedContext = createContext<boolean>(false);

const ListItemButtonSelected = (props: ListItemButtonProps & {routeKey?: string; to: string; urlLevel?: number; isCollapsed?: boolean}) => {
  const {routeKey, urlLevel, isCollapsed = false, ...otherProps} = props;
  const checkOnLevel = urlLevel || 2;
  const location = useLocation();
  const isSelected = location.pathname.split('/')[checkOnLevel] === (routeKey || otherProps.to?.split('/')[checkOnLevel]);

  return (
    <ListItemButtonSelectedContext.Provider value={isSelected}>
      <ListItemButton selected={isSelected} style={isCollapsed ? {} : {whiteSpace: 'break-spaces'}} {...otherProps}>
        {props.children}
      </ListItemButton>
    </ListItemButtonSelectedContext.Provider>
  );
};
export default ListItemButtonSelected;